import { IonCol, IonGrid, IonRow } from '@ionic/react';
import { FC } from 'react';


interface NoDetailsNoticeProps {
  selectedTimeFrameValue: string;
  message?: string;
}


const NoDetailsNotice: FC<NoDetailsNoticeProps> = ({
  selectedTimeFrameValue,
  message,
}) => (
  <IonGrid className='hot-slot-listing'>
    <IonRow>
      <IonCol className='ion-text-center'>
        {message ? (
          <span className='white-p no-data-message'>{message}</span>
        ) : selectedTimeFrameValue === 'month1' ? (
          <span className='white-p no-data-message'>
            The slot might be out of service, as there is no data.
          </span>
        ) : (
          <span className='white-p no-data-message'>
            Please select longer time frame. The slot might not be providing data, we are on it.
          </span>
        )}
      </IonCol>
    </IonRow>
  </IonGrid>
);

export default NoDetailsNotice;
